export const getProfileSaveResult = response => {
    const envelope = response?.response?.data || response?.data;
    if (!envelope || typeof envelope !== 'object') return {success: false, message: 'Unable to reach the server. Please try again.'};
    const status = Number(envelope.statusCode ?? envelope.StatusCode ?? response.status ?? 200);
    const error = envelope.errorMessage || envelope.ErrorMessage;
    if (status >= 400 || error) return {success: false, message: error || envelope.message || envelope.Message || 'Unable to save your profile. Please try again.'};
    let data = envelope.data ?? envelope.Data;
    if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (_) { /* Some endpoints return the message directly. */ }
    }
    const record = Array.isArray(data) ? data[0] : data;
    const message = (typeof record === 'string' ? record : record?.ResponseMsg || record?.responseMsg || record?.message || record?.Message) || envelope.message || envelope.Message || '';
    const success = /^(saved successfully|profile updated successfully|updated successfully)[!.\s]*$/i.test(String(message).trim());
    return {success, message: String(message || 'The server did not confirm the profile update. Please try again.')};
};

export const makeProfileSaveParameters = values => ({
    UserID: Number(values.UserID),
    FirstName: String(values.FirstName || '').trim(),
    LastName: String(values.LastName || '').trim(),
    MobileNo: String(values.MobileNo || '').trim(),
    AddressLineOne: values.AddressLineOne,
    CityId: Number(values.CityId) > 0 ? String(values.CityId) : '-999',
    StateProvinceId: Number(values.StateProvinceId) > 0 ? String(values.StateProvinceId) : '-999',
    PostalCode: String(values.PostalCode || '').trim()
});
